import { APP_INITIALIZER, LOCALE_ID, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard } from '../services/auth.guard';

import { AuthInterceptor } from '../services/auth.interceptor';
import { CountriesService } from '../services/countries.service';
import { QuickCartRouteGuard } from '../quick-cart/quick-cart-route-guard';
import { ProductResolver } from '../product/product.resolver.service';
import { PastordersRouteGuard } from '../../../pastorders-archived/pastorders-route-guard';
import { AddressSuggestionsService } from '../services/address-suggestions.service';
import { CartProvider } from './cart-provider';
import { AuthService } from '../services/auth.service';
import { UnavailableCartItemGuard } from '../services/unavailable-cart-item.guard';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { CatalogueService } from '../web-services/catalogue.service';
import { LocalStorageService } from './local-storage/local-storage.service';
import { AnimationsService } from './animations/animations.service';
import { DEFAULT_TIMEOUT, TimeoutInterceptor } from '../services/http-timeout.interceptor';
import { MyAgentsRouteGuard } from '../my-agents/my-agents-route-guard';
import { PersonaModule } from '../persona/persona.module';
import { NewsModule } from '../news/news.module';
import { Angulartics2Module } from 'angulartics2';
import { en_US } from 'ng-zorro-antd/i18n';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { NZ_ICONS } from 'ng-zorro-antd/icon';
import { NzIconService } from 'ng-zorro-antd/icon';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { Angulartics2GoogleAnalytics } from 'angulartics2';
import { MediaWatcherHelperService } from '@app/core/services/media-watcher-helper.service';
import { cdnBaseUrl } from '@env/environment';
import { icons } from '@app/core/required-ant-icons';
import { MenuLinksService } from '@app/services/menu-links.service';
import { OrderHistoryRouteGuard } from '@app/order-history/order-history-route-guard';
import { WINDOW_PROVIDERS } from '@app/services/window.service';
import { ScrollPositionHelperService } from '@app/core/services/scroll-position-helper.service';
import {
    SamplingSupplyWarningModalComponent
} from '@app/order-checkout/containers/sampling-supply-warning-modal/sampling-supply-warning-modal.component';

export function cartProviderFactory(provider: CartProvider) {
    return () => provider.load();
}

@NgModule({ declarations: [SamplingSupplyWarningModalComponent],
    exports: [
        PersonaModule,
        NewsModule,
        Angulartics2Module,
        NzNotificationModule
    ], imports: [CommonModule,
        PersonaModule,
        NewsModule,
        NzNotificationModule,
        Angulartics2Module.forRoot()], providers: [
        WINDOW_PROVIDERS,
        LocalStorageService,
        CartProvider,
        {
            provide: APP_INITIALIZER,
            useFactory: cartProviderFactory,
            deps: [CartProvider],
            multi: true
        },
        CatalogueService,
        ProductResolver,
        { provide: LOCALE_ID, useValue: 'en-NZ' },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: DEFAULT_TIMEOUT, useValue: 30000 },
        { provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true },
        { provide: NZ_I18N, useValue: en_US },
        { provide: NZ_ICONS, useValue: icons },
        AuthService,
        AuthGuard,
        AnimationsService,
        UnavailableCartItemGuard,
        QuickCartRouteGuard,
        PastordersRouteGuard,
        MenuLinksService,
        MyAgentsRouteGuard,
        OrderHistoryRouteGuard,
        AddressSuggestionsService,
        CountriesService,
        MediaWatcherHelperService,
        ScrollPositionHelperService,
        provideHttpClient(withInterceptorsFromDi(), withJsonpSupport())
    ] })
export class CoreModule {
    constructor(
    @Optional()
    @SkipSelf()
        parentModule: CoreModule,
        angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
        nzIcons: NzIconService
    ) {
        if (parentModule) {
            throw new Error('CoreModule is already loaded. Import only in AppModule');
        }
        angulartics2GoogleAnalytics.startTracking();
        nzIcons.changeAssetsSource(`${cdnBaseUrl}icons`);
    }
}
